module.exports = __webpack_public_path__ + "static/media/rsz_massan-121-fav.37ceb8c8.jpg";